// extracted by mini-css-extract-plugin
export default {"box-container":"multiSelectElement-module__box-container__3Dhzq"};